import React from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { Link } from 'react-router-dom';
import { IFormGridProps } from 'library/types/IFormGridProps'
import { SystemGrid, CheckCrossCell } from 'library'
import { SystemGridAndForm } from '../../library/form/SystemGridForm';
import { SystemActionCell } from '../../library/grid/SystemActionCell';

const CommentsItems = (props: IFormGridProps) => {
    const url = "/AnnuelContract/AnnuelContractByOpportunityId/" + props.data;

    const [counter, setCount] = React.useState(1500);

    const RefreshGrid = () => {
        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    /**
     * @author:Sanju Bishnoi
     * @description: format currency for the amount.
     */
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });

    return <SystemGrid onRowClick={props.onRowClick} pageable={true} dataSource={url} refresh={props.refresh + counter} >
        <Column key={1} field="Year" title="Year" width="auto" />
        <Column key={2} title="Contract Amount" width="auto" cell={(item) => {
            return (<><td>{item.dataItem.ContractAmount ? formatter.format(item.dataItem.ContractAmount) : null}</td></>)
        }} />
        <Column key={3} title="Profit Amount" width="auto" cell={(item) => {
            return (<><td>{item.dataItem.ProfitAmount ? formatter.format(item.dataItem.ProfitAmount) : null}</td></>)
        }} />
        <Column key={4} field="FTECount" title="FTE Count" width="auto" />
        <Column key={5} title="TB Contract Amount" width="auto" cell={(item) => {
            return (<><td>{item.dataItem.TBContractAmount ? formatter.format(item.dataItem.TBContractAmount) : null}</td></>)
        }} />
        <Column key={6} title="TB Profit Amount" width="auto" cell={(item) => {
            return (<><td>{item.dataItem.TBProfitAmount ? formatter.format(item.dataItem.TBProfitAmount) : null}</td></>)
        }} />
        <Column key={7} field="TBFTECount" title="TB FTE Count" width="auto" />
        <Column key={8} field="" title="Action" width="auto" cell={(props) => <SystemActionCell {...props} onDeleteSuccess={RefreshGrid} showDelete={true} showAudit={false} schema="Top" table="AnnualContract" deleteUrl='/AnnuelContract' />} columnMenu={null} />
    </SystemGrid>
}
export default CommentsItems